import { mountIsland, unmountIsland, setupThemeEditorEvents } from "~/lib/islands/bootstrap";
import { sharedQueryClient } from "~/lib/query-client";
import { productContextStore } from "~/lib/product-context/store.svelte";
// ProductBadge appears anywhere on-site (via product-badges.liquid), so its CSS must be
// preloaded on every page via this entry rather than only on PLP/Search entries.
import "~/components/product/ProductBadge/ProductBadge.svelte";

// Expose for devtools integration — set once at startup before any island mounts
window.__TANSTACK_QUERY_CLIENT__ = sharedQueryClient;

// From the global entry, not an island — islands mount lazily on scroll and would
// miss a colour swap that happened before they existed.
productContextStore.listen();

document.addEventListener("DOMContentLoaded", () => {
  mountIsland(document.body);
});

setupThemeEditorEvents({
  onLoad: (section) => mountIsland(section),
  onUnload: (section) => unmountIsland(section),
  onReorder: () => {
    unmountIsland(document.body);
    mountIsland(document.body);
  },
});
